import { Injectable } from '@angular/core';
import { EntityStore, StoreConfig } from '@datorama/akita';
import { DropboxState } from './dropbox.model';
import { LocationStrategy } from '@angular/common';

const initialState = (basePath: string): DropboxState => ({
    connectState: null,
    basePath
});
@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'dropbox', idKey: 'id', resettable: true })
export class DropboxStore extends EntityStore<DropboxState> {
    constructor(private locationStrategy: LocationStrategy) {
        super(initialState(locationStrategy.getBaseHref()));
    }
}
